import type { WidgetPreset } from "../../../nodes/widgets";

const normalize = (s: string) => s.toLowerCase().replace(/[‘’]/g, "'");

/** The gallery filter runs on the label and the meaning, never on the art. */
export function matchesWidgetQuery(preset: WidgetPreset, query: string) {
  const q = normalize(query.trim());
  if (!q) return true;
  return normalize(`${preset.label} ${preset.meaning ?? ""}`).includes(q);
}
